var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.question.type === 'string')?[_c('span',[_vm._v(_vm._s(_vm.answer.value))])]:(_vm.question.type === 'image')?[_c('v-img',{attrs:{"src":_vm.answer.value}})]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }